// extracted by mini-css-extract-plugin
export default {"searchResults":"SearchResults_searchResults__7p9jh"};